/**
 * VNIS template configuration
 * Matches: Mlytics.Vnis
 */
import type { TemplateConfig, TemplateField } from '../types'
import { createExpandedRowRender } from '../../expanded-row'
import { defaultQuotaCalculator, defaultIsExpandable } from '../shared'

// Re-export components
export { default as VnisRegisterForm } from './register-form'
export { default as VnisSelectProvider } from './select-provider'

// ============================================================================
// Fields
// ============================================================================

export const VNIS_FIELDS: TemplateField[] = [
    { key: 'domains', names: ['domains'], label: 'Domains' },
    { key: 'cdn_traffics', names: ['cdn_traffics'], label: 'CDN Traffic' },
    { key: 'cdn_requests', names: ['cdn_requests'], label: 'CDN Requests' },
    { key: 'dns_queries', names: ['dns_queries'], label: 'DNS Queries' },
    { key: 'waf_traffics', names: ['waf_traffics'], label: 'WAF Traffic' },
    { key: 'waf_requests', names: ['waf_requests'], label: 'WAF Requests' },
    {
        key: 'peak_cdn_traffics',
        names: ['peak_cdn_traffics'],
        label: 'Peak CDN Traffic',
    },
    {
        key: 'peak_waf_traffics',
        names: ['peak_waf_traffics'],
        label: 'Peak WAF Traffic',
    },
    {
        key: 'peak_cdn_requests',
        names: ['peak_cdn_requests'],
        label: 'Peak CDN Requests',
    },
    {
        key: 'peak_waf_requests',
        names: ['peak_waf_requests'],
        label: 'Peak WAF Requests',
    },
]

// ============================================================================
// Template Config
// ============================================================================

export const vnisTemplate: TemplateConfig = {
    id: 'vnis',
    patterns: ['mlytics.vnis', 'vnis'],
    priority: 10,

    fields: VNIS_FIELDS,

    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },

    calculateQuota: defaultQuotaCalculator,

    registerForm: {
        type: 'vnis',
        // WAF V2 uses manual registration (default form)
        productGroupOverrides: {
            'WAF V2': 'default',
        },
    },
}

// Export all VNIS templates
export const vnisTemplates = [vnisTemplate]
